import React, { forwardRef } from "react";
import { UserCircle } from "lucide-react";
import { dateLocale } from "i18n";
import { positionLabel } from "v2/constants/positions";

const PlayerRow = forwardRef(({ player, isLast }, ref) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString(dateLocale("en-US"), {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div
      ref={ref}
      className={`flex items-center justify-between px-4 py-3 transition duration-150 hover:bg-[#FAFAFA] ${
        !isLast ? "border-b border-[#F3F4F6]" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#F3F4F6]">
          <UserCircle size={18} className="text-[#6B7280]" />
        </div>
        <div>
          <p className="text-sm font-medium text-[#111827]">{player.name}</p>
          <p className="text-xs text-[#6B7280]">
            {player.workspace_name || "-"}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-6">
        {player.position && (
          <span className="rounded bg-[#F3F4F6] px-1.5 py-0.5 text-[10px] font-medium text-[#6B7280]">
            {positionLabel(player.position)}
          </span>
        )}
        <span className="w-24 text-right text-xs text-[#9CA3AF]">
          {formatDate(player.created_at)}
        </span>
      </div>
    </div>
  );
});

PlayerRow.displayName = "PlayerRow";

export default PlayerRow;
